import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { Data, Day } from './services/data';
import * as moment from 'moment';
import { TargetsComponent } from './targets';
import { smallScreen, formatDate } from './services/util';
var DashboardComponent = /** @class */ (function () {
    function DashboardComponent(data) {
        this.data = data;
        this.history = [];
        this.columnsToDisplay = ['updated', 'weight', 'bodyFatPercentage', 'delete', 'edit'];
        this.mealColumns = ['name', 'time', 'calories', 'carbs', 'fat', 'protein', 'delete', 'edit'];
        this.showTargets = false;
    }
    Object.defineProperty(DashboardComponent.prototype, "smallScreen", {
        get: function () {
            return smallScreen();
        },
        enumerable: true,
        configurable: true
    });
    DashboardComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, _b;
            var _this = this;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.data.getUserHistory()];
                    case 1:
                        _a.history = _c.sent();
                        _b = this;
                        return [4 /*yield*/, this.data.getTodaysEntries()];
                    case 2:
                        _b.today = _c.sent();
                        this.data.renderableChanges.subscribe(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var _a, _b;
                            return tslib_1.__generator(this, function (_c) {
                                switch (_c.label) {
                                    case 0:
                                        _a = this;
                                        return [4 /*yield*/, this.data.getUserHistory()];
                                    case 1:
                                        _a.history = _c.sent();
                                        _b = this;
                                        return [4 /*yield*/, this.data.getMealsForDay(this.today.date)];
                                    case 2:
                                        _b.today = _c.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                        this.targetsChild.hide.subscribe(function () { return _this.setTargets(false); });
                        return [2 /*return*/];
                }
            });
        });
    };
    DashboardComponent.prototype.remoteEntry = function (id) {
        var _this = this;
        this.data.removeUserEntry(id).then(function () {
            _this.history = _this.history.filter(function (e) { return e.id !== id; });
        });
    };
    DashboardComponent.prototype.removeMeal = function (id) {
        var _this = this;
        this.data.removeMeal(id).then(function () {
            var newMeals = _this.today.meals.filter(function (m) { return m.id !== id; });
            _this.today = new Day(_this.today.date, newMeals, _this.today.id);
        });
    };
    DashboardComponent.prototype.prevDay = function () {
        var _this = this;
        var today = moment(this.today.date.toISOString());
        today.day(today.day() - 1);
        this.data.getMealsForDay(today).then(function (day) {
            _this.today = day;
        });
    };
    DashboardComponent.prototype.nextDay = function () {
        var _this = this;
        if (this.canGoForward) {
            var today = moment(this.today.date.toISOString());
            today.day(today.day() + 1);
            this.data.getMealsForDay(today).then(function (day) {
                _this.today = day;
            });
        }
    };
    DashboardComponent.prototype.canGoForward = function () {
        var diff = Math.abs(this.today.date.diff(moment(), 'days'));
        return Math.floor(diff) < 1;
    };
    DashboardComponent.prototype.currentDate = function () {
        if (this.today.date.isSame(moment().startOf('day'))) {
            return 'Today';
        }
        if (Math.max(document.documentElement.clientWidth, window.innerWidth || 0) < 550) {
            return this.today.date.format('M/D/YY');
        }
        return this.today.date.format('ddd MMM Do, YYYY');
    };
    DashboardComponent.prototype.formatBodyDate = function (date) {
        return formatDate(date);
    };
    Object.defineProperty(DashboardComponent.prototype, "descHeader", {
        get: function () {
            if (smallScreen()) {
                return 'Desc';
            }
            return 'Description';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DashboardComponent.prototype, "calHeader", {
        get: function () {
            if (smallScreen()) {
                return 'Cal';
            }
            return 'Calories';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DashboardComponent.prototype, "carbsHeader", {
        get: function () {
            if (smallScreen()) {
                return 'Car';
            }
            return 'Carbs';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DashboardComponent.prototype, "protHeader", {
        get: function () {
            if (smallScreen()) {
                return 'Pro';
            }
            return 'Protein';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DashboardComponent.prototype, "ttlHeader", {
        get: function () {
            if (smallScreen()) {
                return 'Ttl';
            }
            return 'Total';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DashboardComponent.prototype, "bfpHeader", {
        get: function () {
            if (smallScreen()) {
                return 'BF%';
            }
            return 'Body Fat %';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DashboardComponent.prototype, "weightHeader", {
        get: function () {
            if (smallScreen()) {
                return 'Lbs';
            }
            return 'Weight';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DashboardComponent.prototype, "fixedWidth", {
        get: function () {
            if (smallScreen()) {
                return 0;
            }
            return 2;
        },
        enumerable: true,
        configurable: true
    });
    DashboardComponent.prototype.setTargets = function (newValue) {
        this.showTargets = newValue;
    };
    return DashboardComponent;
}());
export { DashboardComponent };
